import type { TFunction } from 'react-i18next'
import {
  ABSENCE_TYPE_TRANSLATIONS,
  ABSENCE_TYPES,
} from 'redesign/components/molecules/timeline-absence-dates/constants'

export const getAbsenceTypesOptions = (t: TFunction) =>
  Object.values(ABSENCE_TYPES).map((value, index) => ({
    value,
    id: index,
    label: t(ABSENCE_TYPE_TRANSLATIONS[value]),
  }))
